import { api } from './api'
import { getSubscriberRequestDTO, updateSubscriberRequestDTO, getListInfoRequestDTO } from './types'
import { checkToken, getRandomInt } from '../utils'

export const getListInfo = ({listId}:getListInfoRequestDTO) =>{
  return api.get(`/lists/${listId}`)
}

export const getSubscriber = ({listId, subscriber}:getSubscriberRequestDTO) =>{
  checkToken(api)
  return api.get(`/lists/${listId}/${subscriber}`)
}

export const updateSubscriber = ({listId, subscriber, requestBody}:updateSubscriberRequestDTO)=>{
  checkToken(api)
  return api.put(`/lists/${listId}/${subscriber}`,requestBody)
}

export const sendAuthEmail = ({listId, subscriber}:getSubscriberRequestDTO) =>{
  return api.post(`/lists/${listId}/${subscriber}/auth`)
}

export const getAccessToken = ({listId, subscriber, query}) =>{
  return api.get(`/lists/${listId}/${subscriber}/auth?${query}&v=${getRandomInt(1000,9999)}`)
}

export const getPaidLogs = ({listId, subscriber, query}) =>{
  checkToken(api)
  return api.get(`/lists/${listId}/${subscriber}/payment?${query}`)
}

export const getCustomerUid = ({listId, subscriber,requestBody}) =>{
  checkToken(api)
  return api.post(`/lists/${listId}/${subscriber}/payment`,requestBody)
}